import { useState } from 'react';
import { Container, Stack, Title, Paper, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useAppUser } from '../../hooks/useAppUser';
import { usePageTitle } from '../../hooks/usePageTitle';
import { CreateReleaseForm } from '../../components/Admin/CreateReleaseForm';
import { ReleaseItemType } from '../../types/release';

export const AdminReleasesPage = () => {
  usePageTitle('Admin Releases | Meals You Love');
  const { user } = useAppUser();
  const [creatingRelease, setCreatingRelease] = useState(false);

  const handleCreateRelease = async (
    version: string,
    items: Array<{ type: ReleaseItemType; title: string; description: string }>
  ) => {
    if (!user) return;

    setCreatingRelease(true);
    try {
      const token = await user.getIdToken();
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/releases`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ version, items }),
      });

      if (response.ok) {
        notifications.show({
          title: 'Release created',
          message: `Release ${version} has been created successfully`,
          color: 'green',
        });
      } else {
        const error = await response.json();
        notifications.show({
          title: 'Error',
          message: error.error || 'Failed to create release',
          color: 'red',
        });
      }
    } catch (error) {
      notifications.show({
        title: 'Error',
        message: 'Failed to create release',
        color: 'red',
      });
    } finally {
      setCreatingRelease(false);
    }
  };

  return (
    <Container size="xl" py="xl">
      <Paper withBorder p="md" radius="lg">
        <Stack gap="md">
          <div>
            <Title order={3}>Release Notifications</Title>
            <Text size="sm" c="dimmed">
              Create new release announcements to notify users about features, improvements, and fixes
            </Text>
          </div>

          <CreateReleaseForm
            onSubmit={handleCreateRelease}
            loading={creatingRelease}
          />
        </Stack>
      </Paper>
    </Container>
  );
};
